angular.module('jv.MyAccount.LiRsc.Ctrl', [
    'jv.common.root-modal.directive',
    'jv.Common.Modal',
    'jv.Common.AjaxSelect',
    'jv.simple-select.directive',
    'jv.Common.i18n'
])
.controller('linkedInRecruiterController', [
    '$scope', '$rootScope', 'myAccount', '$q', '$timeout', 'i18n', '$log',
    function($scope, $rootScope, myAccount, $q, $timeout, i18n, $log) {
    $scope.linkedInPreference = $scope.linkedInPreference || {};
    $scope.linkedInFunction = $scope.linkedInFunction || {};
    $rootScope.breadcrumbsConfig.links.unshift({
            linkText: i18n['LINKEDIN_RECRUITER'],
            link: $scope.jvUrls.admin+'/myaccount/profile.html#/linkedInRecruiter'
    });
    $scope.flags.loading = false;
    var _getLinkedInUserPreference = function(){
        myAccount.getLinkedInUserPreference(function(response){
        if(response.linkedInUserPreference){
        $scope.linkedInPreference = response.linkedInUserPreference;
        }}, function(err){
                $log.error(err);
        });
    };
    $scope.saveLinkedInUserPreference = function(preference,enable){
        if(preference === 'inMail'){
            $scope.linkedInPreference.inMailEnable = enable;
        }else if(preference === 'inNotes'){
            $scope.linkedInPreference.inNotesEnable = enable;
        }
        myAccount.saveLinkedInUserPreference($scope.linkedInPreference, function(res){
            $scope.linkedInPreference = res.linkedInUserPreference;
            $scope.showMsg('SETTINGS_SAVED');
        }, function(err){
                $log.error(err);
        });
    };
    var getLinkedInAdminSetting = function(){
        myAccount.getLinkedInAdminSetting(function(response){
        $scope.linkedInFunction.data = response.linkedInProperties;
        }, function(err){
            $log.error(err);
        });
    };

    _getLinkedInUserPreference();
    getLinkedInAdminSetting();
    }
]);